export default "__VITE_ASSET__Bji4tLtu__"